import {Text} from "components/styled"
import {
    commonLocalization,
    number,
} from "localization"
import React, {
    Component,
    Fragment,
} from "react"
import {connect} from "react-redux"
import {withRouter} from "react-router-dom"
import styled from "styled-components"

class DashboardProjects extends Component {
    constructor() {
        super()
        this.state = {}
    }

    navigateToProject(status) {
        const {fiscalYear, type, projectType} = this.props
        const typeFilter = type === "all" ? "" : type

        if (status === "total_projects") {
            this.props.history.push(`/projects?fiscal-year=${fiscalYear}&type=${typeFilter}&project_type=${projectType}`)
        } else {
            this.props.history.push(
                `/projects/?status=${status}&fiscal-year=${fiscalYear}&type=${typeFilter}&project_type=${projectType}`,
            )
        }
    }

    fragment = (selectedWard, localization) => {
        if (selectedWard === "all") return null

        return localization.stats
    }
    toolip = (key, localization) => {
        const {selectedLanguage} = this.props
        let projects = localization.projects

        if (key === "total_projects" || key === "worth_of_projects") {
            projects = ""
        }

        if (selectedLanguage === "en") {
            return (
                <span>Click to view{" "}
                    <strong style={{textTransform: "uppercase"}}>
                      {localization[key]} {projects}{" "}
                    </strong>
                </span>
            )
        }

        return (
            <span>
            <strong>
              {localization[key]} {projects}{" "}
            </strong>
            हेर्नका लागि थिच्नुहाेस् ।
          </span>
        )
    }

    render() {
        const {
            data,
            selectedDropDown,
            selectedLanguage,
            selectedWard,
        } = this.props
        const localization = commonLocalization[selectedLanguage]

        if (!Object.keys(data).length) {
            return (
                <div style={{overflow: "hidden"}}>
                    <Text.span uppercase>{localization.dataNotAvailable}</Text.span>
                </div>
            )
        }

        return (
            <ProjectsWrap lang={selectedLanguage} className={'flex flex-col'}>
                    <Text.span light className="stats-label dashboard-stats-label">
                        {selectedLanguage === "np" && (
                            <Fragment>
                                <strong>सबै वडाको </strong> <span className="opacity-70">तथ्या्क&nbsp;</span>
                            </Fragment>
                        )}

                        {selectedLanguage === "en" && selectedWard === "all" && (
                            <Fragment>
                                <span className="opacity-70">Stats for</span> <strong>all wards </strong>
                            </Fragment>
                        )}

                        {selectedLanguage === "np" && selectedWard !== "all" && (
                            <Fragment>
                                <strong>वडा {number(selectedWard)}</strong> <span className="opacity-70">का लागि&nbsp;</span>
                            </Fragment>
                        )}

                        {selectedWard !== "all" && <span className="opacity-70">{localization.stats}</span>}

                        {selectedLanguage === "en" && selectedWard !== "all" && (
                            <Fragment>
                                &nbsp;for <strong>Ward {selectedWard}</strong>
                            </Fragment>
                        )}

                    </Text.span>

                <div className={'card--chart flex justify-between items-center w-full card-stats flex-1'} style={{marginTop: 2}}>
                    {Object.keys(data)
                        .map((key, index) => {
                            if (index === 0)
                                return <ProjectsMain
                                    onClick={() => this.navigateToProject(key)}
                                    status={key}
                                    key={key}
                                    className="projects-block self-center">
                                    <div>
                                        <div className="tooltip">
                                            <div className="tooltip-arrow"/>
                                            {this.toolip(key, localization)}
                                        </div>
                                        {selectedDropDown === "budget" ? (
                                            <span className={'flex items-center'}
                                            >  <small
                                                style={{marginRight: 4}}>{selectedLanguage === "en" ? "NRs. " : "नेरु "}</small>
                        <Text.span bold className="projects-value">
                    {data[key] && data[key].split(" ")[0]}
                        </Text.span>
                        <small
                            style={{marginLeft: 4}}> {data[key] ? data[key].split(" ")[1] : ""}</small>
                        </span>
                                        ) : (
                                            <Text.span bold className="projects-value">
                                                {number(data[key])}
                                            </Text.span>
                                        )}

                                        <Text.span uppercase className="projects-title whitespace-nowrap">
                                            {/* {key.replace(/_/g, ' ')} */}
                                            {localization[key]}
                                        </Text.span>
                                    </div>
                                </ProjectsMain>
                        })
                    }
                    <div className={'flex self-stretch flex-col justify-between'}>
                        {Object.keys(data)
                            .map((key, index) => {
                                if (index > 0)
                                    return <ProjectsMain
                                        onClick={() => this.navigateToProject(key)}
                                        status={key}
                                        key={key}
                                        className="projects-block">
                                        <div>
                                            <div className="tooltip">
                                                <div className="tooltip-arrow"/>
                                                {this.toolip(key, localization)}
                                            </div>
                                            {selectedDropDown === "budget" ? (
                                                <span className={'flex items-center'}
                                                >  <small
                                                    style={{marginRight: 4}}>{selectedLanguage === "en" ? "NRs. " : "नेरु "}</small>
                        <Text.span bold className="projects-value">
                    {data[key] && data[key].split(" ")[0]}
                        </Text.span>
                        <small
                            style={{marginLeft: 4}}> {data[key] ? data[key].split(" ")[1] : ""}</small>
                        </span>
                                            ) : (
                                                <Text.span bold className="projects-value">
                                                    {number(data[key])}
                                                </Text.span>
                                            )}

                                            <Text.span uppercase className="projects-title whitespace-nowrap">
                                                {/* {key.replace(/_/g, ' ')} */}
                                                {localization[key]}
                                            </Text.span>
                                        </div>
                                    </ProjectsMain>
                            })
                        }
                    </div>
                </div>
            </ProjectsWrap>
        )
    }
}

export default withRouter(
    connect(state => ({
        selectedLanguage: state.localizationReducers.selectedLanguage,
        fiscalYear: state.fiscalYearReducers.selectedFiscalYear,
    }))(DashboardProjects),
)

const getStatusColor = (theme, type) => {
    switch (type) {
        case "implementation":
            return theme.sec.blue

        case "not_started":
            return theme.dark.charcoalGrey

        case "pipeline":
            return theme.sec.pink

        case "completion":
            return theme.sec.green

        default:
            return theme.dark.charcoalGrey
    }
}

const ProjectsWrap = styled.div`
  width: 100%;
  .projects-title {
    display: block;
    font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
    margin-top: 3px;
  }
  .stats-label {
    font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
    margin-bottom: 8px;
  }
  .projects-block {
    > div {
      position: relative;
      .tooltip {
        font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
        padding: 10px 15px;
        position: absolute;
        opacity: 0;
        visibility: hidden;
        top: 50px;
        left: -73px;
        width: 174px;
        white-space: initial;
      }
      &:hover .tooltip {
        opacity: 1;
        visibility: visible;
      }
    }
    &:first-child > div {
      .tooltip {
        left: -60px;
      }
    }
  }
  
  .projects-block {
    .projects-value {
      font-size: 16px;
    }
  }
`

const ProjectsMain = styled.div`
  cursor: pointer;
  @media all and (min-width: 992px) and (max-width: 1199px) {
    padding-right: 10px;
    width: 23% !important;
    &:nth-child(3) {
      width: 28%!important;
    }
  }

  &:first-child {
    margin-top: 30px;
    white-space: nowrap;
    .projects-value {
      &:before {
        display: none;
      }
    }
  }

  .projects-value {
    font-size: 20px;
    position: relative;
    &:before {
      background-color: ${props => getStatusColor(props.theme, props.status)};
      border-radius: 50%;
      box-shadow: 0 2px 4px 0 #0e1724;
      content: '';
      display: none;
      height: 7px;
      left: -8px;
      position: absolute;
      width: 7px;
      top: 4px;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/visualization/projects/dashboardProjects.js